export const api = {
  queryDeptTree: 'vas/dept/queryDeptTree.json',
  queryDept: 'vas/dept/queryDeptList.json',
  addDeptTree: 'vas/dept/addDept.json',
  deleteDept: 'vas/dept/deleteDept.json',
  updateDept: 'vas/dept/updateDept.json',
  queryPersonList: '/vas/personnel/queryPersonListApi.json'
}
